function BrightnessControl() {
    return null;
}

export default BrightnessControl;
